import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AjudaRotina } from '../models/ajuda-rotina';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class AjudaRotinaService extends AbstractService<AjudaRotina> {
  titulo: string = 'Ajuda das rotinas';

  endpoint(): string {
    return 'admin/ajuda-rotina';
  }

  rotina(): string {
    return 'AJUDA_ROTINA';
  }

  colunas(): any[] {
    return [
      { header: 'Rotina', field: 'rotina' },
      { header: 'Título', field: 'titulo' },
      { header: 'Módulo', field: 'modulo' },
      { header: 'Onde fica', field: 'ondeFica' },
      { header: 'Profundidade', field: 'profundidade' },
    ];
  }

  /**
   * Grava só o texto, pelo endpoint próprio.
   *
   * O save genérico do AbstractController mandaria o objeto inteiro e não marcaria
   * `editadoNaCentral` — e sem essa marca a próxima publicação do catálogo
   * devolveria o texto do repositório por cima da edição feita aqui.
   */
  saveR(o: any): Observable<HttpResponse<any>> {
    const url = this.baseUrl() + '/salvar-texto';
    const corpo = {
      rotina: o.rotina,
      resumo: o.resumo,
      quandoUsar: o.quandoUsar,
      conteudo: o.conteudo,
      publicado: o.publicado,
    };
    const h = new HttpHeaders({
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json',
      'X-Auth-Token': AbstractService.token(),
    });
    return this.http.post<any>(url, JSON.stringify(corpo), {
      headers: h,
      observe: 'response',
    });
  }

  save(o: any): Observable<any> {
    return this.saveR(o);
  }

  novo(selection?: any) {
    // ficha não se cria à mão: ela nasce da publicação do catálogo, que é o que
    // garante que a rotina existe mesmo no menu do ERP
    AbstractService.readonly = true;
    this.router.navigate(['adm/ajuda-rotinas']);
  }

  abrir(obj: AjudaRotina) {
    AbstractService.readonly = true;
    this.router.navigate(['adm/ajuda-rotinas/cadastro'], { queryParams: { id: obj.id } });
  }

  edit(obj: AjudaRotina) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/ajuda-rotinas/cadastro'], { queryParams: { id: obj.id } });
  }

  routeLista() {
    return 'adm/ajuda-rotinas';
  }

  constructor(http: HttpClient, private router: Router, loginService: LoginService) {
    super(http, loginService);
  }
}
